module.exports = __webpack_public_path__ + "static/media/cleo-tablet-738x57@2x.2f4d36f8.webp";